import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    Badge,
    BadgeColors,
    CheckCircleIcon
} from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { TASK_STATUSES } from "shared/types/enums";

import { TaskStatusIconProps } from "./types";

const TaskStatusIcon = ({
    id,
    count,
    verifyAttemptCount
}: TaskStatusIconProps) => {
    const { t } = useTranslation();

    const getBadgeData = (statusId: TASK_STATUSES) => {
        switch (statusId) {
            case TASK_STATUSES.Pending:
            case TASK_STATUSES.Verifying:
                return { color: BadgeColors.premium, isInverted: true };
            case TASK_STATUSES.Running:
                return { color: BadgeColors.info, isInverted: true };
            case TASK_STATUSES.Completed:
                return { color: BadgeColors.success, isInverted: true };
            case TASK_STATUSES.CompletedWithErrors:
                return { color: BadgeColors.warning, isInverted: true };
            case TASK_STATUSES.Cancelled:
                return { color: BadgeColors.neutral, isInverted: false };
            case TASK_STATUSES.Failed:
                return { color: BadgeColors.critical, isInverted: true };
            case TASK_STATUSES.PendingApproval:
                return { color: BadgeColors.light, isInverted: false };
            default:
                return { color: BadgeColors.light, isInverted: true };
        }
    };

    const color = getBadgeData(id).color;
    const isInverted = getBadgeData(id).isInverted;

    const statusName = t(`Task status##${id}`);

    const name = count ? `${count} ${statusName}` : statusName;

    const isCompleted = id === TASK_STATUSES.Completed;
    const hasAttempts = verifyAttemptCount && verifyAttemptCount > 0;
    const isVerified = isCompleted && hasAttempts;

    return (
        <TooltipGeneral
            title={isVerified ? t("Task status##verified tooltip title") : ""}
            placement={TOOLTIP_PLACEMENT.Top}
        >
            <div
                css={css({
                    display: "inline-flex",
                    cursor: isVerified ? "pointer" : "default"
                })}
            >
                <Badge
                    color={color}
                    inverted={isInverted}
                    IconRight={isVerified ? CheckCircleIcon : undefined}
                >
                    {name}
                </Badge>
            </div>
        </TooltipGeneral>
    );
};

export default TaskStatusIcon;
